export const INTERVAL_OPTIONS = [
    {
        label: "ONE",
        value: 1
    },
    {
        label: "SIX",
        value: 6
    },
    {
        label: "TWELVE",
        value: 12
    },
    {
        label: "TWENTY FOUR",
        value: 24
    }
];
export const ROUNDING_OPTIONS = [
    { label: "ZERO", value: "0" },
    { label: "ONE", value: "1" },
    { label: "TWO", value: "2" },
    { label: "THREE", value: "3" },
    { label: "FOUR", value: "4" }
];

export const ATTRIBUTE_OPTIONS = [
    {
        value: "mrr",
        label: "MRR"

    }
];

export const OPERATOR_OPTIONS = [
    {
        value: "+",
        label: "ADD"
    },
    {
        value: "-",
        label: "SUBTRACT"
    },
    {
        value: "*",
        label: "MULTIPLY"
    },
    {
        value: "/",
        label: "DIVIDE"
    }
];

export const VALUE_OPTIONS = [
    {
        label: "ZERO",
        value: "0"
    },
    {
        label: "N/A",
        value: "N/A"
    }
];
export const VISIBILITY_OPTIONS = [
    {
        label: "Always",
        value: "always"
    },
    {
        label: "Only With Value",
        value: "only_with_value"
    },
    {
        label: "Never",
        value: "never"
    }
];
  
export const TAGS_OPTIONS = [
    {
        label: "Auxiliary",
        value: "auxiliary"
    },
    {
        label: "Average",
        value: "average"
    },
    {
        label: "Event Over Time",
        value: "event_over_time"
    },
    {
        label: "Trends",
        value: "trends"
    }
];

export const TYPE_OPTIONS = [
    {
        label: "Company",
        value: "company"
    },
    {
        label: "People",
        value: "people"
    }
];